import React, { Component } from 'react';
import FadeIn from '../common/fadein'

class TermsPageComponent extends Component {
    render() {
        return (
            <div>
                <section className="content-page">
                    <FadeIn duration="slow">
                        <div className="content-content">
                            <h1 className="content-title">
                                Available Soon
                            </h1>
                            <p className="content-subtitle">Follow us for more updates</p>
                        </div>
                    </FadeIn>
                </section>
            </div>
        )
    }
}

export default TermsPageComponent
